import { createComponent } from '@lit/react';
import React from 'react';
import { SDSProcessStep } from '../sds-process-step/sds-process-step';

export const SDSProcessStepWrapper = createComponent({
	tagName: 'sds-process-step',
	elementClass: SDSProcessStep,
	react: React,
	events: {},
});
